export const environment = {
  production: true,
  localurl : 'https://dbjuuv8smb.execute-api.ap-south-1.amazonaws.com/production'
  // localurl : 'http://localhost:4000'
};
